var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11111 11.2222C7.3878 11.2222 7.02614 11.2222 6.72942 11.3017C5.92421 11.5175 5.29526 12.1464 5.07951 12.9516C5 13.2484 5 13.61 5 14.3333V15.2667C5 16.5735 5 17.2269 5.25432 17.726C5.47802 18.165 5.83498 18.522 6.27402 18.7457C6.77315 19 7.42654 19 8.73333 19H15.2667C16.5735 19 17.2269 19 17.726 18.7457C18.165 18.522 18.522 18.165 18.7457 17.726C19 17.2269 19 16.5735 19 15.2667V14.3333C19 13.61 19 13.2484 18.9205 12.9516C18.7047 12.1464 18.0758 11.5175 17.2706 11.3017C16.9739 11.2222 16.6122 11.2222 15.8889 11.2222M15.1111 8.11111L12 5M12 5L8.88889 8.11111M12 5V14.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6cae9afff6e475466844d4c452cecf57.svg";
export { ForwardRef as ReactComponent };